<template lang="pug">
VContainer(:fluid="true")
  div.mt-10.text-center
    h1.text-h1.mb-3 {{ title }}
    p {{ i18n.t("ScriptureIndex.indexDescription") }}

  IndexListBooks.px-4.mt-8(:local-tid="localTid")
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { localesByCode } from "~/i18n/locales";
import { never } from "~/never";

const i18n = useI18n();
const localeConfig = computed(
  () => localesByCode.get(i18n.locale.value) ?? never("Locale not found."),
);
const localTid = computed<string>(() => localeConfig.value.defaultTid);
const title = i18n.t("ScriptureIndex.ScriptureIndex");

useHead({ title });
</script>
